<template>
  <b-container>
    <b-row class="mb-4">
      <b-col>
        <div class="chartHeader mb-2" v-text="header"></div>
        <b-select :options="indicesValues" class="indicator-select" v-model="index"></b-select>
      </b-col>
    </b-row>
    <template v-if="data != null && data.productData !== null && data.dataMin !== null && data.dataMin.length > 0">
      <b-row class="text-middle mb-4" v-if="isMop">
        <b-col :cols="setColumnsChilds">
          <div v-t="'common.minimum'"></div>
          <loading :active="isLoading" :color="loaderColor" :is-full-page="false" loader="spinner"> </loading>
          <highcharts :key="hcKey" :options="costChartMin"></highcharts>
        </b-col>
        <b-col :cols="setColumnsChilds">
          <div v-t="'common.median'"></div>
          <loading :active="isLoading" :color="loaderColor" :is-full-page="false" loader="spinner"> </loading>
          <highcharts :key="hcKey" :options="costChartMed"></highcharts>
        </b-col>
        <b-col :cols="setColumnsChilds">
          <div v-t="'common.maximum'"></div>
          <loading :active="isLoading" :color="loaderColor" :is-full-page="false" loader="spinner"> </loading>
          <highcharts :key="hcKey" :options="costChartMax"></highcharts>
        </b-col>
      </b-row>
      <b-row class="text-middle mb-4" v-else>
        <b-col cols="12">
          <loading :active="isLoading" :color="loaderColor" :is-full-page="false" loader="spinner"> </loading>
          <highcharts :key="hcKey" :options="costChartMed"></highcharts>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col :cols="setColumnsChilds" v-for="chart in isMop ? ['min', 'med', 'max'] : ['opt']" :key="chart">
        <chart-not-available
          :full-page-loading="globalLoading"
          :active-loading="isLoading"
          :if-is-mop="isMop"
        ></chart-not-available>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ChartNotAvailable from './ChartNotAvailable'
import { setChartMenuItemsLang } from '../../utils/formatter'

export default {
  name: 'MarketCompChart',
  components: {
    ChartNotAvailable,
  },
  props: {
    data: { required: true },
    header: { type: String, required: true },
    indicesValues: { required: true },
    chartCategory: { required: true },
    isMop: { type: Boolean },
    globalLoading: { type: Boolean },
    isLoading: { type: Boolean },
    loaderColor: {},
    value: {},
  },

  data() {
    return {
      hcKey: 0,
    }
  },

  methods: {
    commonChartsOptions: function (valueType) {
      const that = this
      return {
        lang: this.setOptions,
        plotOptions: {
          series: {
            turboThreshold: 0,
            cursor: 'pointer',
            events: {
              click: function (event) {
                that.$emit('column-click', {
                  chartCategory: that.chartCategory,
                  valuesType: valueType,
                  isLastColumns: event.point.index === event.point.series.yData.length - 1,
                  min: event.point.x,
                  max: event.point.x2,
                })
              },
            },
          },
        },
        yAxis: {
          allowDecimals: false,
          showLastLabel: true,
          endOnTick: true,
          title: {
            text: this.$t('marketComparation.numberOfProducts'),
          },
        },
        chart: {
          zoomType: 'xy',
          backgroundColor: '#FFFFFF',
          margin: [50, 20, 50, 80],
          height: '60%',
          style: {
            overflow: 'visible', // Fix for context menu option visibility cut
            zIndex: 100, // Fix for context menu option visibility cut
          },
        },
        tooltip: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          allowDecimals: this.indexConfig.allowDecimal,
          plotLines: [
            {
              color: getComputedStyle(document.documentElement).getPropertyValue('--primary'),
              value: this.data.productData[valueType.toLowerCase()],
              width: 2,
              zIndex: 5,
            },
          ],
          labels: {
            formatter: (val) => this.indexConfig.formatter(val.value),
          },
          min:
            this.getMinValue !== null
              ? this.getMinValue > this.data.productData[valueType.toLowerCase()]
                ? this.data.productData[valueType.toLowerCase()]
                : this.getMinValue
              : null,
          max:
            this.getMaxValue !== null
              ? this.getMaxValue < this.data.productData[valueType.toLowerCase()]
                ? this.data.productData[valueType.toLowerCase()]
                : this.getMaxValue
              : null,
          title: {},
          showLastLabel: true,
          endOnTick: true,
          tickAmount: this.indexConfig.tickAmount,
        },
        series: [
          {
            type: 'histogram',
            baseSeries: 's1',
            binWidth: this.indexConfig.binWidth,
            column: {
              pointPlacement: 0.5,
            },
          },
          {
            type: 'scatter',
            data: this.data['data' + valueType],
            id: 's1',
            visible: false,
          },
        ],
      }
    },
  },
  computed: {
    index: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
    indexConfig() {
      return this.indicatorsConfig[this.index]
    },
    setColumnsChilds() {
      return this.isMop ? '4' : '12'
    },
    costChartMin: function () {
      return this.commonChartsOptions('Min')
    },
    costChartMax: function () {
      return this.commonChartsOptions('Max')
    },
    costChartMed: function () {
      return this.commonChartsOptions('Med')
    },
    getMinValue() {
      return Math.min(...this.data['dataMin'].map((el) => el.y))
    },
    getMaxValue() {
      return Math.max(...this.data['dataMax'].map((el) => el.y))
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>

<style lang="scss" scoped>
.indicator-select {
  max-width: 25rem;
}
</style>
